/* ============================================================
   CoRéaa Home & Body — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── NAV SHRINK ON SCROLL ──
  const nav = document.getElementById('cr-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.padding = window.scrollY > 60 ? '0.9rem 3rem' : '1.4rem 3rem';
    }, { passive: true });
  }

  // ── MOBILE MENU ──
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const mobileClose = document.querySelector('.mobile-menu-close');

  function openMenu() {
    mobileMenu?.classList.add('open');
    mobileOverlay?.classList.add('open');
    mobileMenu?.removeAttribute('aria-hidden');
    hamburger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu?.classList.remove('open');
    mobileOverlay?.classList.remove('open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    hamburger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openMenu);
  mobileClose?.addEventListener('click', closeMenu);
  mobileOverlay?.addEventListener('click', closeMenu);

  // Close on nav link click
  mobileMenu?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // ── SCROLL REVEAL ──
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    const reveals = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      reveals.forEach(el => observer.observe(el));
    } else {
      // Fallback for older browsers
      reveals.forEach(el => el.classList.add('visible'));
    }
  } else {
    // Respect reduced motion
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
  }

  // ── SCENT CARD — ADD TO CART (AJAX) ──
  document.querySelectorAll('.scent-link[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      e.preventDefault();

      btn.textContent = 'Adding…';
      btn.style.opacity = '0.7';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

if (res.ok) {
btn.textContent = 'Added ✓';
// Update cart count in nav
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const countEl = document.querySelector('.cart-count');
    if (cart.item_count > 0) {
      if (countEl) {
        countEl.textContent = cart.item_count;
      } else {
        const cartLink = document.querySelector('.nav-cart');
        if (cartLink) {
          const badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.textContent = cart.item_count;
          cartLink.appendChild(badge);
        }
      }
    }
  });
setTimeout(() => {
btn.textContent = 'Add to Cart';
btn.style.opacity = '1';
          }, 1800);
// Dispatch cart update event for any cart drawer
document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          throw new Error('Add to cart failed');
        }
      } catch {
        btn.textContent = 'Try Again';
        btn.style.opacity = '1';
      }
    });
  });

});
// ── PRODUCT PAGE CART COUNT UPDATE ──
document.getElementById('product-form')?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const btn = e.target.querySelector('.product-atc');
  const variantId = document.getElementById('variant-id').value;
  const qty = parseInt(document.getElementById('quantity').value);

  btn.textContent = 'Adding…';
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });

    if (res.ok) {
      btn.textContent = 'Added ✓';

      // Update cart count instantly
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const countEl = document.querySelector('.cart-count');
          if (cart.item_count > 0) {
            if (countEl) {
              countEl.textContent = cart.item_count;
            } else {
              const cartLink = document.querySelector('.nav-cart');
              if (cartLink) {
                const badge = document.createElement('span');
                badge.className = 'cart-count';
                badge.textContent = cart.item_count;
                cartLink.appendChild(badge);
              }
            }
          }
        });

      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 2000);
    } else {
      throw new Error();
    }
  } catch {
    btn.textContent = 'Try Again';
    btn.disabled = false;
  }
});